import { render } from "./Articles.vue?vue&type=template&id=7a4e61a2&scoped=true"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"

import "./Articles.vue?vue&type=style&index=0&id=7a4e61a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4e61a2"]])

export default __exports__